import { REDUCE_POLICY_LOGS } from '../../constants/actions/policy';

export function reducePolicyLogs(payload) {
    return {
        type: REDUCE_POLICY_LOGS,
        payload,
    };
}
